var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLegalServices(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 64,
    viewBox: "0 0 80 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "aa1be0e501fd67d8b1135187e9729358"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ce10ac4d0cd745c55ea14a3bcafc7e69"
  }, /*#__PURE__*/React.createElement("path", {
    id: "79be8899a6871ecd261e3141eda45fae",
    d: "M64 48H56V44H24V48H16V44H0V64H80V44H64V48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "d613f3205531f65988d6053077dcf106",
    d: "M72 16H60V8C60 3.6 56.4 0 52 0H28C23.6 0 20 3.6 20 8V16H8C3.6 16 0 19.6 0 24V40H16V32H24V40H56V32H64V40H80V24C80 19.6 76.4 16 72 16ZM52 16H28V8H52V16Z",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegalServices);
export default __webpack_public_path__ + "static/media/legalServices.e6b0472c19dee0fe73d1cb9d7ed9ff6b.svg";
export { ForwardRef as ReactComponent };